import LoginSchema from '@/app/schema/login/login';
import CategoryProduct from '@/app/schema/product/categoryProduct';
import Customer from '@/app/schema/customer/customer';
import Product from '@/app/schema/product/product';
import Order from '@/app/schema/order/order';
import User from '@/app/schema/user/user';
import Provider from '@/app/schema/provider/provider';

const Schema = {
  LoginSchema,
  CategoryProduct,
  Product,
  Order,
  Customer,
  User,
  Provider
};

export default Schema;
